import { IIncentiveV2Store } from "@/domain/dto/store.incentive-v2.interfaces";
import { defineComponent, inject } from "vue";
import RedirectToRegister from "../Common/RedirectToRegister/RedirectToRegister.vue";
import EmailInput from "../Common/EmailInput.vue";
import PasswordInput from "../Common/Password/PasswordInput/PasswordInput.vue";
import SocialIncentiveButtons from "../SocialIncentiveButtons/SocialIncentiveButtons.vue";
import SubmitButton from "../Common/SubmitButton/SubmitButton.vue";
import LoginForm from "./LoginForm.class";
import { setupComponent } from "@studyportals/vue-platform";
import Divider from "../Divider/Divider.vue";
import GoToForgotPassword from "../Common/GoToForgotPassword/GoToForgotPassword.vue";

export default defineComponent({
	components: {
		EmailInput,
		PasswordInput,
		SocialIncentiveButtons,
		SubmitButton,
		Divider,
		RedirectToRegister,
		GoToForgotPassword,
	},
	setup: () => {
		const store = inject<IIncentiveV2Store>("incentiveV2Store");
		if (!store) throw new Error("incentiveV2Store was not provided");
		const component = new LoginForm(store);
		return setupComponent(component);
	},
});
